export default __webpack_public_path__ + "static/media/myImg.71ded874.png";